<section *ngIf="data"
         class="rte-panel"
         #panelElRef>
  <top-wave *ngIf="data.topWave?.value"></top-wave>
  <div #contentEl [ngClass]="{'rte-panel__left-centered-content' : data.alignLeftCenter?.value,
                   'rte-panel__content' : !data.alignLeftCenter?.value,
                   'rte-panel__content__top-wave' : data.topWave?.value,
                   'rte-panel__content__bottom-wave' : data.bottomWave?.value}">
    <div *ngIf="data.title?.value"
         class="rte-panel__title-wrapper"
         #titleWrapperEl>
      <h2 class="rte-panel__title"
          #titleEl>
        {{ data.title.value }}
      </h2>
    </div>

    <div *ngIf="data.description?.value"
         [innerHTML]="data.description.value | safe"
         #descriptionEl>
    </div>

    <ng-lottie *ngIf="options" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>

    <div *ngIf="data.links?.value"
         class="rte-panel__link"
         [ngClass]="{'rte-panel__link--left-indent' : data.alignLeftCenter?.value}">
      <app-bg-button *ngFor="let link of data.links.value"
                      [buttonColor]="link.color.value"
                      class="rte-panel__button"
                      [data]="link.link.value">
      </app-bg-button>
    </div>
  </div>
  <bottom-curve *ngIf="data.bottomCurve?.value"></bottom-curve>
  <bottom-wave *ngIf="!data.bottomCurve?.value && data.bottomWave?.value"></bottom-wave>
</section>
